import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-4 md:p-6" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Loan Details ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CurrentLoans = _resolveComponent("CurrentLoans")!
  const _component_HeadingWithMargin = _resolveComponent("HeadingWithMargin")!
  const _component_LoanSetHeading = _resolveComponent("LoanSetHeading")!
  const _component_LoanList = _resolveComponent("LoanList")!
  const _component_NoLoans = _resolveComponent("NoLoans")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasLoans)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_CurrentLoans, { onNewLoan: _ctx.createNewLoan }, null, 8, ["onNewLoan"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loanSets, ({ baseInterestRate, loanAmount, loans }, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createVNode(_component_HeadingWithMargin, { tag: "h2" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_LoanSetHeading, _mergeProps({ baseInterestRate, loanAmount }, {
                onDifferentLender: ($event: any) => (_ctx.createNewLoan({ baseInterestRate, loanAmount }))
              }), null, 16, ["onDifferentLender"]),
              _createVNode(_component_LoanList, {
                class: "mt-6",
                loans: loans
              }, null, 8, ["loans"])
            ]))
          }), 128))
        ], 64))
      : (_openBlock(), _createBlock(_component_NoLoans, {
          key: 1,
          onNewLoan: _ctx.createNewLoan
        }, null, 8, ["onNewLoan"]))
  ]))
}